export const isBannerOutdated = (timestampMs) => {
    const date = new Date(Number(timestampMs));
    date.setDate(date.getDate() + 7);
    return Date.now() > date.getTime();
};
